export type TUrlChange = (url: string) => void;

export const EMPTY_IMAGE_LINK = 'https://res.cloudinary.com/dwrvacpsr/image/upload/v1617525478/no-picture_rvexjh.jpg';
